import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectVacancy } from '../../selectors/vacancies';
import { VacancyInfoLayout } from './components/VacancyInfoLayout/VacancyInfoLayout';
import { EAction } from '../../common/repositories/job-vacancies-backend/entities/button/ButtonSchema';
import { VacancyNotFound } from '../../components/NotFound';
import { Block } from '../../components/Block';

export interface IVacancyInfoContainerProps {
  onClickHandler: (action: EAction) => void;
}

export const VacancyInfoContainer: React.FC<IVacancyInfoContainerProps> = ({ onClickHandler }) => {
  const vacancy = useSelector(selectVacancy);

  if (!vacancy) {
    return (
      <Block marginTop={106} marginBottom={54}>
        <VacancyNotFound />
      </Block>
    );
  }

  return (
    <VacancyInfoLayout
      description={vacancy.contents}
      buttons={vacancy.buttons}
      banners={vacancy.banners}
      buttonHandler={onClickHandler}
    />
  );
};
